import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Stacked firewood pile for cottage yards.
const build: (ctx: DecoBuildCtx) => void = ({ tube, box, seed }) => {
  const bark = shade(0x5a3d22, (rand(seed) - 0.5) * 0.15);
  const end = shade(bark, 0.2);
  // Bottom row
  for (let i = 0; i < 4; i++) {
    const z = -0.55 + i * 0.35;
    const r = 0.14 + rand(seed + i) * 0.04;
    tube(0, r, z, r, 1.1, shade(bark, (rand(seed + 10 + i) - 0.5) * 0.1), "x");
    tube(0.56, r, z, r * 0.98, 0.06, end, "x");
    tube(-0.56, r, z, r * 0.98, 0.06, end, "x");
  }
  // Top row
  for (let i = 0; i < 3; i++) {
    const z = -0.35 + i * 0.35;
    const r = 0.13 + rand(seed + 20 + i) * 0.03;
    tube(0, 0.38, z, r, 1.0, shade(bark, (rand(seed + 30 + i) - 0.5) * 0.1), "x");
  }
  // Stake ends
  box(-0.7, 0.35, -0.75, 0.08, 0.7, 0.08, shade(bark, -0.1));
  box(0.7, 0.35, 0.75, 0.08, 0.7, 0.08, shade(bark, -0.1));
};

export default build;
